import { Button, Message, PageHeader, Drawer, Radio } from "@arco-design/web-react";
import { Fragment, useEffect, useRef, useState } from "react";
import "@arco-design/web-react/dist/css/arco.css";
import copy from "copy-to-clipboard";
import axios from "axios";
import * as CodeMirror from "codemirror/lib/codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/mode/jsx/jsx";
import "codemirror/theme/monokai.css";
import "codemirror/addon/scroll/simplescrollbars";
import "codemirror/addon/scroll/simplescrollbars.css";
import { code as CODE_CUSTOM} from './pcCode';
import { getQueryParam, updatePlaygroundUrl } from "./url";

const PC_DEMO_MODES = ["default", "vod", "custom"];

const getInitialDemoMode = () => {
  const demoMode = getQueryParam("demo");

  return PC_DEMO_MODES.includes(demoMode) ? demoMode : "default";
};

const Index = props => {
  const [iframeSrc, setIframeSrc] = useState("");
  const [cmInitCode, setCmInitCode] = useState("");
  const [demoLoading, setDemoLoading] = useState(true);
  const [edited, setEdited] = useState(false);
  const cm = useRef(null);
  const code = useRef({});
  const [codeShow, setCodeShow] = useState(false);
  const [currentTab, setCurrentTab] = useState(getInitialDemoMode);

  useEffect(() => {
    closeLoading();
    readFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const readFile = () => {
    Promise.all([
      axios.get("/demo/sdk/index.pc.html"),
      axios.get("/demo/sdk/index.pc.vodPlayer.html"),
      axios.get("/demo/sdk/custom.auth.pc.html"),
    ]).then(([defaultRes, vodRes, customRes]) => {
      code.current.CODE = defaultRes.data;
      code.current.VOD = vodRes.data;
      code.current.CUSTOM = customRes.data;
      changeDemo(currentTab, false);
    });
  };

  const initCodeMirror = () => {
    cm.current = CodeMirror.fromTextArea(document.getElementById("editor"), {
      mode: currentTab === 'custom' ? 'jsx' : 'htmlmixed',
      theme: "monokai",
      extraKeys: { Ctrl: "autocomplete" },
      lineNumbers: true,
      value: "",
      lineWrapping: false,
      scrollbarStyle: "overlay",
    });
    cm.current.setValue(cmInitCode);
    cm.current.setSize("", "100%");
    cm.current.on("changes", () => setEdited(true));
  };

  const goNow = () => {
    setIframeSrc(cm.current.doc.getValue());
    setCodeShow(false);
    closeLoading();
  };

  const openModal = () => {
    setCodeShow(true);
    setTimeout(() => {
      if (cm.current) {
        cm.current.setOption('mode', currentTab === 'custom' ? 'jsx' : 'htmlmixed')
      } else {
        initCodeMirror();
      }
    }, 300);
  }

  const closeLoading = () => {
    setDemoLoading(true);
    setTimeout(() => {
      setDemoLoading(false);
    }, 2000);
  };

  const handleCopy = () => {
    copy(cm.current.doc.getValue());
    Message.success("复制成功");
  };

  const changeDemo = (mode, shouldUpdateUrl = true) => {
    let str = "";
    let cmCode = "";
    switch (mode) {
      case "custom":
        str = code.current.CUSTOM;
        cmCode = CODE_CUSTOM;
        break;
      case "vod":
        str = code.current.VOD;
        cmCode = code.current.VOD;
        break;
      case "default":
      default:
        str = code.current.CODE;
        cmCode = code.current.CODE;
    }
    if (cm.current) {
      cm.current.doc.setValue(cmCode);
    }
    setCurrentTab(mode);
    setCmInitCode(cmCode);
    closeLoading();
    setEdited(false);
    setIframeSrc(str);
    if (shouldUpdateUrl) {
      updatePlaygroundUrl({ platform: "pc", demo: mode });
    }
  };

  return (
    <div className="container">
      <PageHeader
        style={{ background: "var(--color-bg-2)" }}
        title="火山引擎企业直播 Web SDK"
        subTitle={
          <Fragment>
            PC端 demo playground &nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.volcengine.com/docs/3019/101258"
              style={{
                color: "rgb(var(--primary-6))",
                textDecoration: "none",
              }}
              rel="noreferrer"
            >
              接入文档
            </a>
            <Button
              type="primary"
              style={{ marginLeft: 12 }}
              onClick={() => {
                props.setIsPc(false);
                updatePlaygroundUrl({ platform: "mobile", demo: "default" });
              }}
            >
              切换至移动端 Demo
            </Button>
          </Fragment>
        }
        extra={
          <div>
            <Button
              type="primary"
              style={{ marginRight: 12 }}
              onClick={openModal}
              loading={demoLoading}
            >
              {currentTab === 'custom' ? '查看代码' : '编辑代码'}
            </Button>
            <Radio.Group
              mode="fill"
              type="button"
              size="large"
              value={currentTab}
              onChange={changeDemo}
            >
              <Radio value="default">标准直播间</Radio>
              <Radio value="vod">点播播放器</Radio>
              <Radio value="custom">第三方用户态直播间</Radio>
            </Radio.Group>
          </div>
        }
      />
      <div className="bottom-container">
        {iframeSrc && (
          <iframe
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="pc preview"
            srcDoc={iframeSrc}
          ></iframe>
        )}
      </div>
      <Drawer 
        title='代码编辑器'
        visible={codeShow}
        footer={null}
        mountOnEnter={false}
        onConfirm={goNow}
        onCancel={() => setCodeShow(false)}
        width={'60%'}
        unmountOnExit={false}
      >
        <div className="pc-drawer-content">
          <div style={{ textAlign: 'right' }}>
            {currentTab !== 'custom' && <Button
              type="primary"
              style={{ marginRight: 12 }}
              onClick={goNow}
              loading={demoLoading}
              disabled={!edited}
            >
              立即预览
            </Button>}
          <Button
              type="outline"
              style={{ marginRight: 12 }}
              onClick={handleCopy}
            >
              一键复制
            </Button>
          </div>
          <div className="cmContainer" style={{ marginRight: 0, marginBottom: 0 }}>
            <textarea id="editor" style={{ display: 'none' }}></textarea>
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default Index;
